module.exports = "/virtual-football-league/img/amblems/right/logos/OSASUMA.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/OSASUMA.png
// module id = 2218
// module chunks = 4